import cn from "classnames";
import { SingleButtonSelectorField } from "src/components/FormField/SingleButtonSelectorField";
import { SingleCheckboxSelectorField } from "src/components/FormField/SingleCheckboxSelectorField";
import { IRenderFormField } from "src/@types/form";
import { StepperField } from "src/components/FormField/StepperField";
import {
  LEGAL_FORM_OPTIONS,
  IND_ENT_SINGLE_TAX_GROUP_OPTIONS,
  IND_ENT_TAXATION_SYSTEM_OPTIONS,
  YES_NO_OPTIONS,
  LEG_ENT_TAXATION_SYSTEM_OPTIONS,
  LEG_ENT_SINGLE_TAX_GROUP_OPTIONS,
} from "./calculator-options";
import { CalculatorField } from "../types";

const DEFAULT_LABEL_CLASSNAME = "text-sm break-words md:text-base";

//  common fields - (from)
export const LEGAL_FORM_FIELD: IRenderFormField = {
  component: SingleButtonSelectorField,
  label:
    "Щоб перейти до наступного кроку, натисніть на один із варіантів нижче",
  labelClassName: cn(DEFAULT_LABEL_CLASSNAME, "text-white-base"),
  name: CalculatorField.legalForm,
  options: LEGAL_FORM_OPTIONS,
};
// (to)

// fields for individual-entrepreneur (ФОП) - (from)
export const IND_ENT_TAXATION_SYSTEM_FIELD: IRenderFormField = {
  component: SingleCheckboxSelectorField,
  className: "flex-col",
  label: "Оберіть систему оподаткування вашого ФОП",
  labelClassName: DEFAULT_LABEL_CLASSNAME,
  name: CalculatorField.taxationSystem,
  options: IND_ENT_TAXATION_SYSTEM_OPTIONS,
};

export const IND_ENT_SINGLE_TAX_GROUP_FIELD: IRenderFormField = {
  component: SingleCheckboxSelectorField,
  label: "Оберіть вашу групу",
  labelClassName: DEFAULT_LABEL_CLASSNAME,
  name: CalculatorField.singleTaxGroup,
  options: IND_ENT_SINGLE_TAX_GROUP_OPTIONS,
};

export const IND_ENT_HIRED_WORKERS_FIELD: IRenderFormField = {
  component: SingleCheckboxSelectorField,
  name: CalculatorField.hiredWorkers,
  options: YES_NO_OPTIONS,
};

export const IND_ENT_WORKERS_COUNT_FIELD: IRenderFormField = {
  component: StepperField,
  name: CalculatorField.workersCount,
  min: 1,
  max: 10000,
};
// (to)

// fields for legal entity (юо) - (from)
export const LEG_ENT_TAXATION_SYSTEM_FIELD: IRenderFormField = {
  component: SingleCheckboxSelectorField,
  className: "flex-col",
  label: "Оберіть систему оподаткування вашої ЮО",
  labelClassName: DEFAULT_LABEL_CLASSNAME,
  name: CalculatorField.taxationSystem,
  options: LEG_ENT_TAXATION_SYSTEM_OPTIONS,
};

export const LEG_ENT_SINGLE_TAX_GROUP_FIELD: IRenderFormField = {
  component: SingleCheckboxSelectorField,
  label: "Оберіть вашу групу",
  labelClassName: DEFAULT_LABEL_CLASSNAME,
  name: CalculatorField.singleTaxGroup,
  options: LEG_ENT_SINGLE_TAX_GROUP_OPTIONS,
};

export const LEG_ENT_VAT_PAYER_FIELD: IRenderFormField = {
  component: SingleCheckboxSelectorField,
  name: CalculatorField.vatPayer,
  options: YES_NO_OPTIONS,
};

export const LEG_ENT_EXCISE_TAX_PAYER_FIELD: IRenderFormField = {
  component: SingleCheckboxSelectorField,
  name: CalculatorField.exciseTaxPayer,
  options: YES_NO_OPTIONS,
};
// (to)
